import FastImage from 'react-native-fast-image';
import LinearGradient from 'react-native-linear-gradient';
import {ScrollView} from 'react-native-gesture-handler';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled(ScrollView)`
  padding: 0 24px;
`;

export const Hero = styled.View`
  border-bottom-left-radius: ${RFValue(24)}px;
  border-bottom-right-radius: ${RFValue(24)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const HeroHeader = styled.View`
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

export const HeroTitle = styled.View`
  flex: 1;
  padding-right: ${RFValue(12)}px;
`;

export const Badge = styled.View`
  background-color: ${({theme}) => theme.colors.shape};
  padding: ${RFValue(6)}px ${RFValue(10)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.primary};
`;

export const BadgeText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  text-transform: uppercase;
`;

export const CardContainer = styled.View`

`;

export const CardSurface = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(12)}px;
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  shadow-color: #000;
  shadow-opacity: 0.05;
  shadow-radius: 6px;
  shadow-offset: 0px 4px;
  elevation: 2;
`;

export const CardTopRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap:${RFValue(12)}px;
`;

export const CardTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const CardBadge = styled.View`
  padding: ${RFValue(6)}px ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.background_black};
  border-radius: ${RFValue(16)}px;
`;

export const CardBadgeText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const CardImageContainer = styled.View`
  margin-top: ${RFValue(12)}px;
  border-radius: ${RFValue(12)}px;
  overflow: hidden;
`;

export const CardImage = styled(FastImage)`
  width: 100%;
  height: 220px;
`;

export const StoresContainer = styled.View`
  
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const FormSurface = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(12)}px;
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  shadow-color: #000;
  shadow-opacity: 0.04;
  shadow-radius: 6px;
  shadow-offset: 0px 4px;
  elevation: 1;
`;

export const Form = styled.View`
  margin-top: ${RFValue(8)}px;
`;

export const ButtonSearch = styled.TouchableOpacity``;

export const SearchInput = styled.TouchableOpacity`
margin-top: ${RFValue(8)}px;
`;

export const SectionDescription = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(11)}px;
  margin-top: ${RFValue(4)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const CategorySection = styled.View`
  margin-top: ${RFValue(12)}px;
padding: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  shadow-color: #000;
  shadow-opacity: 0.04;
  shadow-radius: 6px;
  shadow-offset: 0px 4px;
  elevation: 1;
`;

export const CategoryHeader = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;


`;

export const StoreScrollContainer = styled(ScrollView)`
  margin-top: ${RFValue(12)}px;

`;

export const StoreContainer = styled.View`
  margin-top: ${RFValue(12)}px;
  
`;

export const StoresList = styled.View`
  
`;

export const StoresColumnList = styled.View`
  flex-direction: row;
  gap:${RFValue(12)}px;
`;

export const StoresColumn = styled.View`
  flex-direction: column;
    gap:${RFValue(12)}px;
`;
